import React, { useEffect, useRef } from "react";
import "./GettingStarted.css";
import MinimizedView from "./MinimizedView/MinimizedView";
import MaximizedView from "./MaximizedView/MaximizedView";
import useAdminDataStore, {
  selectGettingStartedExpanded,
} from "../../store/adminData/adminData";

const GettingStarted = () => {
  const maxizedViewRef = useRef(null);

  const expanded = useAdminDataStore(selectGettingStartedExpanded);
  const setGettingStartedExpanded = useAdminDataStore(
    (state) => state.setGettingStartedExpanded,
  );

  const handleClickOutside = (event) => {
    if (
      maxizedViewRef.current &&
      !maxizedViewRef.current.contains(event.target)
    ) {
      setGettingStartedExpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="getting-started" ref={maxizedViewRef}>
      <MaximizedView />
      <div className={`minimized-view-container ${expanded ? "visible" : ""}`}>
        <MinimizedView />
      </div>
    </div>
  );
};

export default GettingStarted;
